import styled from 'styled-components';
export const PaginationContainer = styled.div `
  display: flex;
  flex: 1;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  height: 2.5rem;
  margin-bottom: 1rem;
  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
    width: 2.75rem;
    min-height: 2.75rem;
    min-width: 2.75rem;
  }
`;
export const PaginationWrapper = styled.div `
  justify-content: center;
  margin-top: 2rem;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  height: 2.75rem;

  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
  }
  @media ${({ theme }) => theme.device.medium} {
    flex-direction: row;
    height: 2.5rem;
  }
`;
export const PaginationExtraContainer = styled.div `
  justify-content: center;
  display: flex;
  flex-direction: row;
`;
